import { isGuardianDomain } from './domain.js';
const ACCOUNT_ID = 1257;
const PRIVACY_MANAGER_USNAT = 1068329;
const PROPERTY_ID_MAIN = 7417;
const PROPERTY_ID_SUBDOMAIN = 38161;
const PROPERTY_ID_AUSTRALIA = 13348;
const PROPERTY_HREF_SUBDOMAIN = "https://subdomain.theguardian.com";
const PROPERTY_HREF_MAIN = "https://test.theguardian.com";
const PRIVACY_MANAGER_TCFV2 = 106842;
const PRIVACY_MANAGER_TCFV2_CONSENT_OR_PAY = 1263449;
const PRIVACY_MANAGER_AUSTRALIA = 1178486;
const ENDPOINT = isGuardianDomain() ? "https://sourcepoint.theguardian.com" : "https://cdn.privacy-mgmt.com";
const SourcePointChoiceTypes = {
    AcceptAll: 11,
    ManageCookies: 12,
    RejectAll: 13,
    Dismiss: 15
};
const consentOrPayCountries = ["GB"];
export { ACCOUNT_ID, ENDPOINT, PRIVACY_MANAGER_AUSTRALIA, PRIVACY_MANAGER_TCFV2, PRIVACY_MANAGER_TCFV2_CONSENT_OR_PAY, PRIVACY_MANAGER_USNAT, PROPERTY_HREF_MAIN, PROPERTY_HREF_SUBDOMAIN, PROPERTY_ID_AUSTRALIA, PROPERTY_ID_MAIN, PROPERTY_ID_SUBDOMAIN, SourcePointChoiceTypes, consentOrPayCountries };
